import { render, staticRenderFns } from "./specialGoodsOrder.vue?vue&type=template&id=3ff5b8e8&"
import script from "./specialGoodsOrder.vue?vue&type=script&lang=js&"
export * from "./specialGoodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./specialGoodsOrder.vue?vue&type=style&index=0&id=3ff5b8e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports